import React, { useState } from 'react';
import { CommentsDrawer } from './CommentsDrawer';
import { ConditionSection } from './ConditionSection';
import { ConditionsHeader } from './ConditionsHeader';
import { ConditionsTableHeader } from './ConditionsTableHeader';
import { LinkDocumentsDialog } from './LinkDocumentsDialog';
import { useConditions } from '../../hooks/useConditions';
import type { SortKey, SortState } from '../../types/conditions';
export function ConditionsPanel() {
  const state = useConditions();
  const [sort, setSort] = useState<SortState | null>(null);

  /** Click cycles: ascending → descending → original order. */
  function cycleSort(key: SortKey) {
    setSort(prev => {
      if (!prev || prev.key !== key) return {
        key,
        direction: 'asc'
      };
      if (prev.direction === 'asc') return {
        key,
        direction: 'desc'
      };
      return null;
    });
  }
  const visibleIds = [...state.outstandingGroups.flatMap(g => g.conditions), ...state.cleared].map(c => c.id);
  const allSelected = visibleIds.length > 0 && visibleIds.every(id => state.selectedIds.has(id));
  const someSelected = visibleIds.some(id => state.selectedIds.has(id));
  const sectionProps = {
    sort,
    selectedIds: state.selectedIds,
    onToggleSelect: state.toggleSelect,
    onUpdate: state.updateCondition,
    onComments: state.openComments,
    onUpload: state.uploadDocument,
    onLinkDocuments: state.openLinkDocuments
  };
  return <article className="rounded-xl border border-slate-200 bg-white shadow-sm" data-id="element-157" data-mp="34zj2yt4mzoj4">
      <div data-id="element-158" data-mp="30213rugf8nob">
        <ConditionsHeader conditions={state.conditions} attentionFilter={state.attentionFilter} onAttentionFilterChange={state.setAttentionFilter} selectedCount={state.selectedIds.size} data-id="element-159" data-mp="3029gnmcjnszi" />

        <div role="table" aria-label="Conditions" data-id="element-160" data-mp="2r2mcwtwceb3a">
          <ConditionsTableHeader sort={sort} onSort={cycleSort} allSelected={allSelected} someSelected={someSelected} onToggleSelectAll={() => state.toggleSelectAll(visibleIds)} data-id="element-161" data-mp="1kl94gqkbwar1" />
          {state.outstandingGroups.map(group => <ConditionSection key={group.id} title={group.label} conditions={group.conditions} emptyMessage={`No outstanding ${group.label.toLowerCase()} conditions.`} {...sectionProps} data-id="element-162" data-mp="1m020rq6i3svl" />)}
          <ConditionSection title="Cleared" conditions={state.cleared} emptyMessage="No cleared conditions yet." defaultOpen={false} showCategory {...sectionProps} data-id="element-163" data-mp="ybioz0o8sxyr" />
        </div>
      </div>

      <CommentsDrawer condition={state.commentCondition} onClose={state.closeComments} onSubmit={state.addComment} data-id="element-164" data-mp="tcfx6hx9wo8q" />
      <LinkDocumentsDialog condition={state.linkCondition} onClose={state.closeLinkDocuments} onLink={state.linkDocuments} data-id="element-165" data-mp="fcenccz166h4" />
    </article>;
}